import React from "react";

const VerifyLinkBankOtp: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-6 bg-fin-bg">
            <div className="w-full max-w-sm bg-fin-surface border border-fin-border rounded-2xl p-8 text-center">
                <div className="h-16 w-16 bg-fin-primary/10 rounded-full flex items-center justify-center mb-6 border border-fin-primary/20 mx-auto">
                    <svg className="h-8 w-8 text-fin-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                </div>
                <h1 className="text-xl font-bold text-white mb-2">Verify Bank OTP</h1>
                <p className="text-fin-slate text-sm">Please enter the security code provided by your bank to authorize this link.</p>
                <div className="mt-8 space-y-4">
                    <div className="animate-pulse bg-fin-bg h-12 rounded-xl border border-fin-border"></div>
                    <div className="bg-fin-primary/10 h-12 rounded-xl border border-fin-primary/30"></div>
                </div>
            </div>
        </div>
    );
};

export default VerifyLinkBankOtp;
